import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import "./ServicePhases.css"; // Import the CSS file

const phases = [
  {
    title: "PHASE 1: DISCOVER",
    subtitle: "EVALUATE. EDUCATE. GET TO KNOW YOUR PROJECT AND OBJECTIVES.",
    description:
      "Your company is unique and so is your product or service. We’ll get to know what makes you tick and what makes your customers take notice.",
  },
  {
    title: "PHASE 2: DEFINE",
    subtitle: "SCOPE. SPECIFY. LOOK AT ALL POSSIBLE SOLUTIONS.",
    description:
      "With plenty of your input, we’ll map out a customized plan, refine our joint vision and begin to plant the seeds.",
  },
  {
    title: "PHASE 3: DELIVER",
    subtitle: "DESIGN. BUILD. DEPLOY. LET THE IDEA TAKE ROOT.",
    description:
      "A plan is only as good as its implementation. We’ll dig deep to create and perfect the tangible parts of the plan and begin to move everything forward, keeping a laser focus on our objectives.",
  },
  {
    title: "PHASE 4: DRIVE",
    subtitle:
      "WE HAVE ONE SIMPLE RULE: IF IT DOESN’T HELP YOU GROW, STOP WATERING IT.",
    description:
      "Your time and money are too valuable to waste on ineffective branding. That said, measurable improvement doesn’t happen overnight. We prefer to partner with clients long-term, implementing strategies that produce tangible results over time. We want to be the change that triggers growth.",
  },
];

const ServicePhases = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const checkVisibility = () => {
    if (sectionRef.current) {
      const rect = sectionRef.current.getBoundingClientRect();
      setIsVisible(rect.top < window.innerHeight && rect.bottom > 0);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", checkVisibility);
    return () => window.removeEventListener("scroll", checkVisibility);
  }, []);

  return (
    <div ref={sectionRef} className="container">
      <motion.section
        className="servicePhases"
        initial={{ opacity: 0, y: 50 }}
        animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 1 }}
      >
        {phases.map((phase, index) => (
          <motion.div
            key={index}
            className="phaseBox"
            initial={{ opacity: 0, y: 50 }}
            animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
            transition={{ duration: 0.8, delay: index * 0.2 }}
          >
            <h1 style={{ fontSize: "30px" }}>{phase.title}</h1>
            <p className="subheading">{phase.subtitle}</p>
            <span style={{fontFamily:'Montserrat, sans-serif'}}>{phase.description}</span>
          </motion.div>
        ))}
      </motion.section>

      <motion.div
        className="quote"
        initial={{ opacity: 0, y: 20 }}
        animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
        transition={{ duration: 1, delay: 0.5 }}
        style={{fontfamily: 'Montserrat, sans-serif',backgroundColor:'#8C6652',borderradius: '6px',padding: '12px 0px 3px 0px',
        color: 'white',borderRadius:'10px'}}
      >
        <p style={{marginTop:'5px',fontSize:'17px'}} >❝ A brand is what a business does, reputation is what people remember ❞</p>
      </motion.div>
    </div>
  );
};

export default ServicePhases;
